
































import { defineComponent, reactive, } from '@vue/composition-api'

export default defineComponent({

  setup(props, context) {
    const state = reactive<{
      playerName: string;
    }>({
      playerName: '',
    })

    function setPlayerName(): void {
      context.emit('setPlayerName', state.playerName)
    }

    function cancel(): void {
      context.emit('cancel')
    }

    return {
      state,
      setPlayerName,
      cancel,
    }
  }
})
